export default __webpack_public_path__ + "assets/images/gift_small.a9e272.png";